// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDW8Ax9iguw09S4K_gz5JIIrAq5bEyJxvw",
  authDomain: "draelizabethlinkx.firebaseapp.com",
  projectId: "draelizabethlinkx",
  storageBucket: "draelizabethlinkx.firebasestorage.app",
  messagingSenderId: "746040749845",
  appId: "1:746040749845:web:bd8315ff35e9298bfbc31c",
  measurementId: "G-JNDELQWNDE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
